import { render, staticRenderFns } from "./EditTeamUsersDialog.vue?vue&type=template&id=517d8a0c&scoped=true"
import script from "./EditTeamUsersDialog.vue?vue&type=script&lang=js"
export * from "./EditTeamUsersDialog.vue?vue&type=script&lang=js"
import style0 from "./EditTeamUsersDialog.vue?vue&type=style&index=0&id=517d8a0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517d8a0c",
  null
  
)

export default component.exports